<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      :footer="!viewOpType"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      {{opType | optionText(OpEnum.typeOption)}}{{ productType | optionText(ProductEnum.typeOption) }}
    </template>
    <template #content>
<!--      <p>{{form | json}}</p>-->
      <el-form
          ref="form"
          v-loading="loading"
          :model="form"
          label-width="130px"
          :label-suffix="viewOpType ? '' : ''"
          style="height: 100%; display: flex; flex-direction: column;">
        <el-row type="flex">
          <div class="product--img">
            <gj-image
                v-if="viewOpType"
                :src="form.smallImageUrl"
                :size="125"
            ></gj-image>
            <gj-upload
                v-else
                :imageUrl.sync="form.smallImageUrl"
                container-type="product"
                type="image"
                fileRoleType="public"
                img-height="125px"
                img-width="125px"
            ></gj-upload>
          </div>
          <div class="product__header--info" :class="{'noBack-info': viewOpType}">
            <el-form-item
                label="SKU"
                prop="sku"
                :rules="[
                  { required: !viewOpType, message: '请输入SKU', trigger: ['blur', 'change'] },
                  $gjReRule(RE.specialExceptPoint, '禁止使用“空格、*、×、#”这类特殊符号', false)
                ]">
              <template v-if="viewOpType">{{form.sku | defaultShow}}</template>
              <gj-input
                  v-else
                  v-model="form.sku"
                  class="form-input"
                  placeholder="建议用字母加数字，禁止用“空格、*、×、#”这类特殊符号"
                  :disabled="editOpType"
              ></gj-input>
            </el-form-item>
            <el-form-item
                label="产品名称"
                prop="name"
                :rules="[
                  { required: !viewOpType, message: '请输入产品名称', trigger: ['blur', 'change'] },
                ]">
              <template v-if="viewOpType">{{form.name | defaultShow}}</template>
              <gj-input
                  v-else
                  v-model="form.name"
                  class="form-input"
                  placeholder="产品名称">
              </gj-input>
            </el-form-item>
            <el-form-item
                label="图片链接"
                prop="smallImageUrl"
                placeholder="图片链接"
                style="margin-bottom: 0;"
            >
              <template v-if="viewOpType">{{form.smallImageUrl | defaultShow}}</template>
              <gj-input
                  v-else
                  v-model="form.smallImageUrl"
                  class="form-input"
                  width="250px">
              </gj-input>
            </el-form-item>
          </div>
        </el-row>
        <div class="product__body--info">
          <el-tabs value="baseInfo">
            <el-tab-pane label="基本信息" name="baseInfo">
              <app-product-base-form
                  ref="baseForm"
                  :form="form"
                  :product-type="productType"
                  :op-type="opType"
                  :mount-to="$mountTo"
              ></app-product-base-form>
            </el-tab-pane>
            <el-tab-pane label="采购信息" name="purchaseInfo" lazy>
              <app-product-purchase-form
                  ref="purchaseForm"
                  :op-type="opType"
                  :form="form"
              ></app-product-purchase-form>
            </el-tab-pane>
            <el-tab-pane label="物流信息" name="transportInfo" lazy>
              <app-product-transport-form
                  ref="transportForm"
                  :op-type="opType"
                  :form="form"
              ></app-product-transport-form>
            </el-tab-pane>
            <el-tab-pane label="FBA尾程(预估)" name="lastInfo">
              <app-product-fba-tail
                  ref="fbaTailForm"
                  :op-type="opType"
                  :form="form"
              ></app-product-fba-tail>
            </el-tab-pane>
            <el-tab-pane
                v-if="$permission('product:viewSupplier') && (opType === OpEnum.type.UPDATE || opType === OpEnum.type.VIEW)"
                label="报价信息" name="offerInfo" lazy>
              <app-product-offer-form
                  ref="offerForm"
                  :op-type="opType"
                  :form="form"
                  :mount-to="$mountTo"
              ></app-product-offer-form>
            </el-tab-pane>
            <el-tab-pane
                v-if="opType === OpEnum.type.UPDATE || opType === OpEnum.type.VIEW"
                label="操作日志" name="log">
              <app-product-operate-log
                  :op-type="opType"
                  url="/supply/product/logPage"
                  :params="{model: {fid: product.id}}"
              ></app-product-operate-log>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, opTypeMixin,userGuideMixin} from "../../../../../../minxins";
  import {OpEnum, ProductEnum} from "../../../../../../utils/options";
  import AppProductBaseForm from "./product-base-form";
  import AppProductPurchaseForm from "./product-purchase-form";
  import AppProductTransportForm from "./product-transport-form";
  import AppProductOperateLog from "./product-operate-log";
  import AppProductFbaTail from "./product-fba-tail";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../utils/common";
  import {addProduct, getProductBySku, updateProduct} from "../../../../../../api/product";
  import {RESPONSE_CODE} from "../../../../../../utils/const";
  import AppProductOfferForm from "./product-offer-form";

  export default {
    name: "app-product-add-modal",
    components: {
      AppProductOfferForm,
      AppProductFbaTail,
      AppProductOperateLog, AppProductTransportForm, AppProductPurchaseForm, AppProductBaseForm},
    mixins: [modalMixIn, formRuleMixin, opTypeMixin,userGuideMixin],
    props: {
      product: {
        required: false
      },
      productType: {
        required: false
      },
      sku: {
        required: false
      },
      opType: {
        type: Number,
        default: OpEnum.type.ADD
      }
    },
    data() {
      return {
        OpEnum: OpEnum,
        loading: false,
        uploadImageUrl: 'blob:https://element.eleme.cn/475582ef-8b92-4809-8fba-76c871010a05',
        form: {
          sku: null,
          smallImageUrl: null,
          name: null,
          // 基本信息
          categoryId: null,
          brandId: null,
          unit: null,
          state: ProductEnum.status.ACTIVE,
          productDeveloperId: null,
          productDesc: null,
          description: null,
          childProducts: [],
          // 采购信息
          buyerId: null,
          expectDeliveryDays: null,
          material: null,
          singleProductSizeL: null,
          singleProductSizeW: null,
          singleProductSizeH: null,
          singleProductNetWeight: null,
          packageW: null,
          packageL: null,
          packageH: null,
          packageWeight: null,
          cartonSizeH: null,
          cartonSizeL: null,
          cartonSizeW: null,
          singleNetWeight: null,
          singleWeight: null,
          singleQuantity: null,
          // 物流信息
          tax: {
            currency: 'CNY',
            price: null,
          },
          chineseCustomsName: null,
          englishCustomsName: null,
          customsCode: [
            {countryCode: 'CN', code: null},
            {countryCode: 'US', code: null},
            {countryCode: 'CA', code: null},
            {countryCode: 'UK', code: null},
            {countryCode: 'DE', code: null},
            {countryCode: 'IT', code: null},
            {countryCode: 'FR', code: null},
            {countryCode: 'NL', code: null},
            {countryCode: 'ES', code: null},
            {countryCode: 'AU', code: null},
            {countryCode: 'SG', code: null},
            {countryCode: 'JP', code: null},
            {countryCode: 'IN', code: null},
            {countryCode: 'AE', code: null},
            {countryCode: 'SA', code: null}
          ],
          // FBA尾程
          clothing: false,
        },
        ProductEnum: ProductEnum
      }
    },
    created() {
      if (this.opType === OpEnum.type.UPDATE
        || this.opType === OpEnum.type.COPY
        || this.opType === OpEnum.type.VIEW) {
        this.loading = true;
        getProductBySku(this.sku)
          .then((product) => {
            Object.assign(this.form, product);
            if (this.opType === OpEnum.type.COPY) {
              this.form.sku = null;
              this.form.name = null;
            }
            this.form.tax = {
              currency: product.dutyCurrency,
              price: product.dutyPrice,
            };
            if (isMeaningful(product.customsCodeJson)) {
              this.form.customsCode = JSON.parse(product.customsCodeJson);
            }
            if (this.productType === ProductEnum.type.ASSEMBLY) {
              this.form.childProducts = product.productAssemblyList.map(item => ({
                sku: item.sku,
                quantity: item.quantity,
                name: item.name,
                smallImageUrl: item.smallImageUrl
              }));
            }
          })
          .complete(() => this.loading = false);
      }
    },
    computed: {
      productParams() {
        return {
          ...this.form,
          productType: this.productType,
          dutyCurrency: this.form.tax.currency,
          dutyPrice: this.form.tax.price,
          customsCodeJson: JSON.stringify(this.form.customsCode.map(item => ({
            countryCode: item.countryCode,
            code: defaultVal(item.code, null)
          }))),
          assembly: this.productType === ProductEnum.type.ASSEMBLY
            ? this.form.childProducts.map(item => `${item.sku}*${item.quantity}`).join('+')
            : null
        };
      }
    },
    methods: {
      confirm() {
 
        if (this.formValidate()) {
          this.confirmLoading = true;
          if (this.opType === OpEnum.type.ADD || this.opType === OpEnum.type.COPY) {
            addProduct(this.productParams)
              .then((res) => {
                if (res.code === RESPONSE_CODE.SUCCESS) {
                  this.$gjMessage.success('添加成功');
                   if(this.userGuideState) {
                      this.$emit('userGuide')
                    }
                  this.$gjDestroy();
                  this.$emit('created');
                } else {
                  this.$gjMessage.error(res.msg);
                }
              })
              .complete(() => this.confirmLoading = false);
          } else if (this.opType === OpEnum.type.UPDATE) {
            updateProduct(this.productParams)
              .then((res) => {
                if (res.code === RESPONSE_CODE.SUCCESS) {
                  this.$gjMessage.success('更新成功');
                  this.$gjDestroy();
                  this.$emit('updated');
                } else {
                  this.$gjMessage.error(res.msg);
                }
              })
              .complete(() => this.confirmLoading = false);
          }
        }
      },
      formValidate() {
        let formValid = false;
        this.$refs.form.validate((valid) => {
          formValid = valid;
        });
        // 验证子form
        formValid = ['baseForm', 'purchaseForm', 'transportForm', 'fbaTailForm']
          .map(e => this.$refs[e])
          .filter(ref => isMeaningful(ref))
          .every(ref => {
            return ref.formValidate();
          }) && formValid;
        if (formValid
          && this.productType === ProductEnum.type.ASSEMBLY
          && (isMeaningless(this.form.childProducts) || this.form.childProducts.length === 0)) {
          this.$gjMessage.error('请添加子产品');
          return false;
        }
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .product__header--info .form-input {
    width: 400px !important;
  }
  .product__body--info {
    margin-top: 5px;
    flex: 1;
    overflow: auto;
  }
  .text-form-item /deep/ .el-form-item__label,
  .text-form-item /deep/ .el-form-item__content {
    line-height: 30px;
  }
  /deep/ .el-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  /deep/ .el-tabs__header {
    margin-bottom: 13px;
  }
  /deep/ .el-tabs__content{
    flex: 1;
    overflow: auto;
  }
  /deep/ .el-tab-pane{
    height: 100%;
  }
  /deep/ .el-table--group,
  /deep/ .el-table--border {
    border: 1px solid #DCDFE6;
    border-bottom: none;
    border-right: none;
  }

  /deep/ .gj-union--input > .el-form-item__content {
    display: flex;
  }
  /deep/ .gj-union--input .el-form-item:not(:last-child) input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  /deep/ .gj-union--input .el-form-item:not(:first-child) input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }
  /deep/ .el-tabs__item {
    font-size: 13px;
  }
  // 只在详情页面生效
  .noBack-info{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 20px;
    }
    /deep/ .el-form-item{
      margin-bottom: 12px;
    }
  }
  /deep/ .el-tabs__item.is-active{
    font-weight: bold;
  }
  .product--img{
    max-height: 133px;
  }
</style>
